import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row, Dropdown, MenuProps, Badge, Menu, Button, Tag } from "antd";
import { UserOutlined, MenuOutlined, HomeOutlined, ShopOutlined } from "@ant-design/icons";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";
import "./Header.css";

export interface HeaderProps {
  toggleSidebar: (collapsed: boolean) => void;
}

const Header = (props: HeaderProps) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const userEmailAddress = cookies.get("USER_EMAIL");
  const createMenu = (
    <Menu
      items={[
        {
          label: userEmailAddress,
          key: "userEmailAddress",
        },
        {
          type: "divider",
        },
        {
          label: "Logout",
          key: "logout",
          style: { fontWeight: "bold", textAlign: "center" },
          onClick: () => logout(),
        },
      ]}
    />
  );
  let currOffice = cookies.get("CURR_OFFICE");
  const officeInfo: any = {
    pg: { className: "pg-office", name: "Penang Office ( PG )" },
    bw: { className: "bw-office", name: "Butterworth Office ( BW )" },
  };
  const logout = () => {
    removeTokenFromCookies();
    navToLogin();
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const navToNewPurchase = () => {
    navigate("/newpurchase");
  };

  const navToHome = () => {
    navigate("/");
  };
  return (
    <Row className="header-bar">
      <Col span={8}>
        <Row justify="start">
          <MenuOutlined className="icon-menu" onClick={() => props.toggleSidebar(false)} />
          <HomeOutlined className="icon-home" onClick={() => navToHome()} />
          {currOffice === "" || currOffice === undefined ? (
            <Button
              onClick={() => navToHome()}
              icon={<ShopOutlined />}
              style={{ fontWeight: "bold", marginTop: "-8px", marginLeft: "20px" }}
              className="select-office"
            >
              Select an Office
            </Button>
          ) : (
            <Tag
              icon={<ShopOutlined />}
              color="default"
              className={
                officeInfo[currOffice] === undefined || officeInfo[currOffice] === null
                  ? ""
                  : officeInfo[currOffice].className
              }
            >
              {officeInfo[currOffice] === undefined || officeInfo[currOffice] === null
                ? ""
                : officeInfo[currOffice].name}
            </Tag>
          )}
        </Row>
      </Col>
      <Col span={8}>
        <Row justify="center" align="middle" className="header-row">
          <h2 className="header-name" onClick={() => navToNewPurchase()}>
            Metals Trading
          </h2>
        </Row>
      </Col>
      <Col span={8}>
        <Row justify="end">
          {process.env.REACT_APP_ENV === "dev" && <h2 style={{ color: "yellow" }}>Local Development</h2>}
          <Dropdown
            overlay={createMenu}
            trigger={["click"]}
            overlayClassName="plus-dropdown"
            overlayStyle={{ width: "300px" }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <UserOutlined className="icon-create" />
            </a>
          </Dropdown>
        </Row>
      </Col>
    </Row>
  );
};

export default Header;
